<template>
  <main class="main internetDirect" role="main" v-if="isCompleted">
    <div class="main_con" id="con_fixed" @scroll="handleScroll">
      <div class="top_img">
        <img
          :src="
            require('@/assets/front/images/internetDirect/img_internet_top.png')
          "
          alt=""
        />
      </div>
      <div class="list_tab" ref="list_tab" :class="{ tab_fix: isTabFixed }">
        <ul>
          <li :class="{ on: isTelecom == 'SKT' }" @click="selectTelecom('SKT')">
            SKT
          </li>
          <li :class="{ on: isTelecom == 'KT' }" @click="selectTelecom('KT')">
            KT
          </li>
          <li :class="{ on: isTelecom == 'LGU' }" @click="selectTelecom('LGU')">
            LGU+
          </li>
        </ul>
      </div>
      <div class="list_con" id="list_con">
        <div class="skt_list" v-if="isSktView">
          <div>
            <img
              :src="
                require('@/assets/front/images/internetDirect/img_view_direct_skt_01.png')
              "
              alt=""
            />
          </div>
          <div>
            <img
              :src="
                require('@/assets/front/images/internetDirect/img_view_direct_skt_02.png')
              "
              alt=""
            />
          </div>
          <div>
            <img
              :src="
                require('@/assets/front/images/internetDirect/img_view_direct_skt_03.png')
              "
              alt=""
            />
          </div>
        </div>
        <div class="kt_list" v-if="isKtView">
          <div>
            <img
              :src="
                require('@/assets/front/images/internetDirect/img_view_direct_kt_01.png')
              "
              alt=""
            />
          </div>
          <div>
            <img
              :src="
                require('@/assets/front/images/internetDirect/img_view_direct_kt_02.png')
              "
              alt=""
            />
          </div>
          <div>
            <img
              :src="
                require('@/assets/front/images/internetDirect/img_view_direct_kt_03.png')
              "
              alt=""
            />
          </div>
        </div>
        <div class="lg_list" v-if="isLgView">
          <div>
            <img
              :src="
                require('@/assets/front/images/internetDirect/img_view_direct_lg_01.png')
              "
              alt=""
            />
          </div>
          <div>
            <img
              :src="
                require('@/assets/front/images/internetDirect/img_view_direct_lg_02.png')
              "
              alt=""
            />
          </div>
          <div>
            <img
              :src="
                require('@/assets/front/images/internetDirect/img_view_direct_lg_03.png')
              "
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="btm_btn" @click="internetDirectSend">
      <div class="btn_wrap">
        <button class="btn">신청하기</button>
      </div>
    </div>
    <SendModal
      ref="sendModal"
      @close="closeSendModal"
      @agreeSend="agreeSend"
      :nickname="user.nickname"
    ></SendModal>
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '신청이 완료되었습니다!',
        type: 'alert',
        msg: `퍼스 인터넷 고객센터(1533-2783)에서 조만간 연락을 드릴 예정이며, 전국번호가 스팸으로 등록된 건 아닌지 확인 부탁드립니다.`,
      }"
      @close="popupClose"
    />
  </main>
</template>
<script>
import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import SendModal from '@/front/customer/views/internetDirect/modal/SendModal';
import DesignPopup2 from '@/common/components/modal/DesignPopup2';
import {
  sleep,
  connectedSocket,
  closeSocket,
  checkMobileOperatingSystem,
  setCallbackOnClickBackKey,
  nativeEnableBackKey,
  nativeDisableBackKey,
  jsonEscape,
  toBR,
} from '@common/lib/common/utils';
export default {
  components: {
    SendModal,
    DesignPopup2,
  },
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      setCallbackOnClickBackKey(vm.handleOnClickBackKey);
    });
  },
  beforeDestroy(vm) {
    setCallbackOnClickBackKey();
  },
  data() {
    return {
      isCompleted: false,
      isTelecom: 'SKT',
      isTabFixed: false,
      isSktView: true,
      isKtView: false,
      isLgView: false,
      designPopup: false,
    };
  },
  async created() {
    this.isCompleted = true;
  },
  async mounted() {
    await this.fetchMe();
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME]),
    ...internetMapActions([internetTypes.CREATE_INTERNET_DIRECT_SUBMIT]),
    async fetchMe() {
      await this[userTypes.FETCH_ME]();
    },
    handleOnClickBackKey() {
      this.closeSendModal();
    },
    selectTelecom(sel) {
      this.isTelecom = sel;
      if (sel == 'SKT') {
        this.isSktView = true;
        this.isKtView = false;
        this.isLgView = false;
      } else if (sel == 'KT') {
        this.isSktView = false;
        this.isKtView = true;
        this.isLgView = false;
      } else if (sel == 'LGU') {
        this.isSktView = false;
        this.isKtView = false;
        this.isLgView = true;
      }
    },
    handleScroll() {
      var target = this.$refs.list_tab;
      var targetTop = target.getBoundingClientRect().top;
      console.log('targetTop = ' + targetTop);

      var targetCon = document.getElementById('list_con');
      var targetTopCon = targetCon.getBoundingClientRect().top;
      console.log('targetTopCon = ' + targetTopCon);

      if (targetTop <= 53 && targetTopCon <= 89) {
        this.isTabFixed = true;
      } else {
        this.isTabFixed = false;
      }
    },
    internetDirectSend() {
      this.$refs.sendModal.isOpen = true;
      nativeDisableBackKey();
    },
    closeSendModal() {
      this.$refs.sendModal.isOpen = false;
      nativeEnableBackKey();
    },
    async agreeSend() {
      this.closeSendModal();
      await this[internetTypes.CREATE_INTERNET_DIRECT_SUBMIT]({
        userId: this.user.id,
        time: this.$refs.sendModal.timeValue,
        telecom: this.$refs.sendModal.telecomValue,
      });
      this.designPopup = true;
    },
    async popupClose() {
      this.$router.push({ name: 'Home' });
    },
  },
};
</script>
